module.exports = __webpack_public_path__ + "src-notif-booking.png?93ce6cb1d6fe90c307e8680be0c48be1";